import { colorBlue, colorGreen, colorPeach } from '@/styles';

const COLORS = ['#b9a86e', '#f57c00', '#e57373'];

export const getColor = (index: number) => COLORS[index % COLORS.length];
